// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsTeamUpdateDto
 */
export interface IClaimsTeamUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IClaimsTeamUpdateDto
     */
    allowed_services?: Array<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IClaimsTeamUpdateDto
     */
    assigned_organizations_ids?: Set<number>;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsTeamUpdateDto
     */
    is_generic_claims_team?: boolean;
}

/**
 * Check if a given object implements the IClaimsTeamUpdateDto interface.
 */
export function instanceOfIClaimsTeamUpdateDto(value: object): value is IClaimsTeamUpdateDto {
    return true;
}

export function IClaimsTeamUpdateDtoFromJSON(json: any): IClaimsTeamUpdateDto {
    return IClaimsTeamUpdateDtoFromJSONTyped(json, false);
}

export function IClaimsTeamUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'allowed_services': json['allowed_services'] == null ? undefined : json['allowed_services'],
        'assigned_organizations_ids': json['assigned_organizations_ids'] == null ? undefined : new Set(json['assigned_organizations_ids']),
        'is_generic_claims_team': json['is_generic_claims_team'] == null ? undefined : json['is_generic_claims_team'],
    };
}

export function IClaimsTeamUpdateDtoToJSON(json: any): IClaimsTeamUpdateDto {
    return IClaimsTeamUpdateDtoToJSONTyped(json, false);
}

export function IClaimsTeamUpdateDtoToJSONTyped(value?: IClaimsTeamUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'allowed_services': value['allowed_services'],
        'assigned_organizations_ids': value['assigned_organizations_ids'] == null ? undefined : Array.from(value['assigned_organizations_ids'] as Set<any>),
        'is_generic_claims_team': value['is_generic_claims_team'],
    };
}

